import { actionCreator,
  checkHttpStatus,
  GET_MASTER_LOCATIONS_API,
  GET_MASTERDATABYNAME,
  jsonApiHeader,
  locationMasterActionTypes,
  POST_MASTER_LOCATION_API,
  showErrorMessage,
  showSuccessMessage,
  showWarningMessage,
  GET_MASTER_LOCATION_DETAILS_API,
  DELETE_MASTER_LOCATION_API,
} from '../constants/ApiConstants';

import {
  loginActionTypes,
  USERASSIGNEDLOCATIONS,
} from '../../../../logins/constants/ApiConstants';
import { checkHttpStatusAuthCheck, createSearchUrlForCustomAPI } from '../../../../../actions/utilAction';


export const getMasterLocationsList = (searchObj) => {
  let query_params = createSearchUrlForCustomAPI(searchObj);
  return (dispatch, getState) => {
    dispatch(actionCreator(locationMasterActionTypes.get_masterLocationsList.REQUEST));
    fetch(`${GET_MASTER_LOCATIONS_API}${query_params}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(locationMasterActionTypes.get_masterLocationsList.SUCCESS, response));
        } else {
          dispatch(actionCreator(locationMasterActionTypes.get_masterLocationsList.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error get_masterLocationsList  --', error);
      });
  };
};
export const getMasterData = (masterDataList) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(locationMasterActionTypes.get_masterdata.REQUEST));
    if (masterDataList === '' || masterDataList === undefined) {
      masterDataList = 'masterCountry,masterState,MASTERPATIENTLOCATION,MASTEREVVDETAILS';
    }
    fetch(`${GET_MASTERDATABYNAME}`, {
      method: 'post',
      body: JSON.stringify({ 'masterdata': masterDataList }),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
      .then(function(response) {
        dispatch(actionCreator(locationMasterActionTypes.get_masterdata.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('error master location masterdata ', error);
      });
  };
};
export const saveLocationMaster = (formProps, userID) => {
  // console.log('formProps ===', formProps);
  // let fetchMethod = formProps.id ? 'PATCH' : 'POST';
  // let idUrl = formProps.id ? `/${formProps.id}` : '';
  // let PostData = JSON.stringify({
  //   data: {
  //     type: 'location',
  //     attributes: {
  //       Code: formProps.Code,
  //       LocationName: formProps.LocationName,
  //       Address: formProps.Address,
  //       City: formProps.City,
  //       StateID: formProps.StateID,
  //       Zip: formProps.Zip,
  //       CountryID: formProps.CountryID,
  //       LocationDescription: formProps.LocationDescription,
  //       OrganizationID: formProps.OrganizationID,
  //       FacilityCode: formProps.FacilityCode,
  //       FacilityNPINumber: parseInt(formProps.FacilityNPINumber, 10),
  //       FacilityProviderNumber: parseInt(formProps.FacilityProviderNumber, 10),
  //       BillingTaxId: parseInt(formProps.BillingTaxId, 10),
  //       BillingNPINumber: parseInt(formProps.BillingNPINumber, 10),
  //       OfficeStartHour: formProps.OfficeStartHour,
  //       OfficeEndHour: formProps.OfficeEndHour,
  //       MileageRate: formProps.MileageRate,
  //       Phone: formProps.Phone,
  //       Latitude: formProps.Latitude,
  //       Longitude: formProps.Longitude,
  //       BillingProviderInfo: formProps.BillingProviderInfo,
  //       ApartmentNumber: formProps.ApartmentNumber,
  //       StandardTime: formProps.StandardTime,
  //       DaylightSavingTime: formProps.DaylightSavingTime,
  //     },
  //   },
  // });
  // let UpdateData = JSON.stringify({
  //   data: {
  //     type: 'location',
  //     id: formProps.id,
  //     attributes: {
  //       Code: formProps.Code,
  //       LocationName: formProps.LocationName,
  //       Address: formProps.Address,
  //       City: formProps.City,
  //       StateID: formProps.StateID,
  //       Zip: formProps.Zip,
  //       CountryID: formProps.CountryID,
  //       LocationDescription: formProps.LocationDescription,
  //       OrganizationID: formProps.OrganizationID,
  //       FacilityCode: formProps.FacilityCode,
  //       FacilityNPINumber: parseInt(formProps.FacilityNPINumber, 10),
  //       FacilityProviderNumber: parseInt(formProps.FacilityProviderNumber, 10),
  //       BillingTaxId: parseInt(formProps.BillingTaxId, 10),
  //       BillingNPINumber: parseInt(formProps.BillingNPINumber, 10),
  //       OfficeStartHour: formProps.OfficeStartHour,
  //       OfficeEndHour: formProps.OfficeEndHour,
  //       MileageRate: formProps.MileageRate,
  //       Phone: formProps.Phone,
  //       Latitude: formProps.Latitude,
  //       Longitude: formProps.Longitude,
  //       BillingProviderInfo: formProps.BillingProviderInfo,
  //       ApartmentNumber: formProps.ApartmentNumber,
  //       StandardTime: formProps.StandardTime,
  //       DaylightSavingTime: formProps.DaylightSavingTime,
  //     },
  //   },

  // });
  // let formPostData = (formProps.id) ? UpdateData : PostData;
  // console.log(formPostData);
  return (dispatch, getState) => {
    dispatch(actionCreator(locationMasterActionTypes.post_masterLocation.REQUEST));
    fetch(`${POST_MASTER_LOCATION_API}`, {
      method: 'POST',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      body: JSON.stringify(formProps),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(locationMasterActionTypes.post_masterLocation.SUCCESS, response));
          if (userID)
            dispatch(getAssignedUserLocations(userID));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(locationMasterActionTypes.post_masterLocation.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error post_masterLocation ', error);
      });
  };
};

export const getmasterLocationDetails = (locationId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(locationMasterActionTypes.get_masterLocationDetails.REQUEST));
    fetch(`${GET_MASTER_LOCATION_DETAILS_API}?id=${locationId}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(locationMasterActionTypes.get_masterLocationDetails.SUCCESS, response));
        } else {
          dispatch(actionCreator(locationMasterActionTypes.get_masterLocationDetails.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error get_masterLocationDetails --', error);
      });
  };
};

export const deleteMasterLocationDetails = (locationMasterID) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(locationMasterActionTypes.delete_masterLocation.REQUEST));
    fetch(`${DELETE_MASTER_LOCATION_API}?id=${locationMasterID}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then((response) => {
        if (response.statusCode === 200 || response.statusCode === 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(locationMasterActionTypes.delete_masterLocation.SUCCESS, response));
        } else if (response.statusCode === 401 || response.statusCode === 422) {
          showWarningMessage(response.message);
          dispatch(actionCreator(locationMasterActionTypes.delete_masterLocation.SUCCESS, null));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(locationMasterActionTypes.delete_masterLocation.SUCCESS, null));
        }
      }).catch(function(error) {
        console.log('error delete_masterLocation ', error);
      });
  };
};

export const ResetLocationDetails = () => {
  return (dispatch) => {
      dispatch(actionCreator(locationMasterActionTypes.get_masterLocationDetailsReset.SUCCESS, 0));
  }
}

// export const getLocationBySearchText = (searchObj) => {
//   let query_params = createSearchUrl(searchObj);
//   let fetchUrl = `${LOCATIONMASTERAPI}${query_params}`;

//   return (dispatch, getState) => {
//     dispatch(actionCreator(locationMasterActionTypes.get_location_master.REQUEST));
//     fetch(fetchUrl, {
//       method: 'get',
//       headers: jsonApiHeader(getState().login.access_token, 'application/vnd.api+json'),
//     })
//       .then(checkHttpStatus)
//       .then(function(response) {
//         dispatch(actionCreator(locationMasterActionTypes.get_location_master.SUCCESS, response));
//       })
//       .catch(function(error) {
//         console.log('error get_location_master  --', error);
//       });
//   };
// };


export const getAssignedUserLocations = (userId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(loginActionTypes.get_user_Assigned_locations.REQUEST));
    // console.log(`${USERASSIGNEDLOCATIONS}?userId=${userId}`)
    fetch(`${USERASSIGNEDLOCATIONS}?userId=${userId}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/vnd.api+json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log('response Assigned Location........', response)
        dispatch(actionCreator(loginActionTypes.get_user_Assigned_locations.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('error: ', error);
      });
  };
};


// WEBPACK FOOTER //
// ./src/modules/Masters/components/location-master/actions/LocationMasterActions.js